import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';
import { Cloud, Sun, Wind } from 'lucide-react';
import toast from 'react-hot-toast';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="weather-header">
        <div className="weather-icons">
          <Sun className="weather-icon sun" />
          <Cloud className="weather-icon cloud" />
          <Wind className="weather-icon wind" />
        </div>
        <h1>WeatherCast Pro</h1>
        <p>Your trusted source for weather information</p>
      </div>

      <div className="login-form-container">
        <div className="login-form">
          <h2>Access Your Weather Dashboard</h2>
          <p>Sign in to view personalized weather updates and forecasts</p>
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <button 
              type="submit" 
              className="login-btn"
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Access Dashboard'}
            </button>
          </form>

          <div className="form-footer">
            <p>Don't have an account? 
              <Link to="/register" className="link"> Create one here</Link>
            </p>
          </div>
        </div>
      </div>

      <div className="weather-footer">
        <p>© 2024 WeatherCast Pro. Providing accurate weather forecasts worldwide.</p>
      </div>
    </div>
  );
};

export default Login;
